import { PageLayout } from '@/shared/layout/PageLayout';
import { Scale } from 'lucide-react';

export function UnitsPage() {
  return (
    <PageLayout title="Đơn vị tính" description="Quản lý các đơn vị đo lường sử dụng trong hệ thống">
      <div className="flex flex-col items-center justify-center p-20 bg-white rounded-md border border-slate-200 text-slate-500">
        <Scale className="w-16 h-16 mb-6 text-slate-300" />
        <h3 className="text-lg font-semibold text-slate-800 mb-2">Đơn vị tính đang sử dụng Enum</h3>
        <p className="text-center max-w-md sm:text-sm text-xs text-slate-500">
          Hệ thống hiện tại đang sử dụng danh sách đơn vị tính mặc định (Static Text) lưu trực tiếp trên từng vật tư. 
          Việc quản lý động sẽ được mở khóa nếu nâng cấp schema `units`.
        </p>
      </div>
    </PageLayout>
  );
}

export default UnitsPage;
